<template>
    <v-dialog v-model="open" max-width="600px" persistent>
      <v-card>
        <v-card-title>New Product</v-card-title>
        <v-card-text><v-row><v-col cols="12">COT/COP products should be created using the COT/COP menu items on the product page of an existing product.</v-col></v-row></v-card-text>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select v-model="productKind" label="Product kind" :error-message="productKindError" @change="$v.productKind.$touch()" :items="productKinds" dense outlined hide-details></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider style="margin: 20px 0;"></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small :disabled="saving" :loading="saving" @click="save">Create</v-btn>
          <v-btn color="primary" outlined small :disabled="saving" @click="closeDialog">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";


export default {
  mixins: [validationMixin],

  validations: {
    productKind: { required },
  },

  props: {
    open: Boolean,
    close: Function,
    account: Number
  },

  data: () => ({
    productKind: null,
    productKinds: [
       {text:'Telco',value: 'TELCO'},
       {text:'VOIP',value: 'VOIP'},
       {text:'Website',value: 'WEB'},
    ],
    saving: false,
  }),

  computed: {
    productKindError() {
      const errors = [];
      if (!this.$v.productKind.$dirty) return errors;
      !this.$v.productKind.required && errors.push("productKind is required");
      return errors;
    },
  },

  methods: {
    ...mapActions("products", ["createProduct"]),

    async save() {
      if(!this.$v.$invalid) {
        this.saving = true;
        try {
          const product = await this.createProduct({accountId: this.account, data: {product_kind: this.productKind, account_id: this.account}});
          this.saving = false;
          if (product) {
            this.closeDialog();
            this.$router.push(`/products/${product.id}/`);
          }
        } catch(error) {
            this.saving = false;
        }
      }
    },

    closeDialog() {
      this.clearData();
      this.close();
      this.$v.$reset();
    },

    clearData() {
      this.productKind = "";
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
